import {Suspense} from "react";
import {
    AnswersStatisticsSearchContainer,
} from "../../components/statistics/filters/AnswersStatisticsSearchContext";
import {AnswersStatisticsFiltersComponent} from "../../components/statistics/filters/answers-statistics-filters";
import {BaseScreen} from "../../../infecto-lms-admin/screens/BaseScreen";
import {AnswersStatisticsTableComponent} from "../../components/statistics/answers-statistic-table";

export const AnswersStatisticScreen = () => {

    return 	(
        <BaseScreen>
        <h1>Tracking</h1>
        <AnswersStatisticsSearchContainer>

        <AnswersStatisticsFiltersComponent/>

        <Suspense fallback={<div>Lade...</div>}>
            <AnswersStatisticsTableComponent/>
        </Suspense>

        </AnswersStatisticsSearchContainer>
        </BaseScreen>)
}
